const urlReducer = (state = {}, action = { type: null }) => {
    switch (action.type) {
        case 'SET_URL':
        case 'UPDATE_AND_REMOVE_URL':
            return action.payload;
        case 'UPDATE_URL':
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
export default urlReducer;
